import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "bg-[#23242A] text-white px-6 pt-1 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto" }
const _hoisted_2 = {
  key: 0,
  class: "custom-full"
}
const _hoisted_3 = {
  key: 1,
  class: "bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]"
}
const _hoisted_4 = { class: "mb-3" }
const _hoisted_5 = { class: "text-[24px] text-white px-4 pt-4" }
const _hoisted_6 = { class: "flex justify-between relative" }
const _hoisted_7 = { class: "flex flex-row border-l border-[#464851] pl-4" }
const _hoisted_8 = {
  key: 0,
  class: "absolute top-14 right-0 w-60 mt-1 z-10 rounded-md shadow-lg"
}
const _hoisted_9 = {
  role: "listbox",
  "aria-labelledby": "listbox-label",
  "aria-activedescendant": "listbox-item-3",
  class: "bg-gray-black max-h-56 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm"
}
const _hoisted_10 = { class: "w-[114px] hover:opacity-70 rounded text-center flex justify-center items-center ml-4 bg-white" }
const _hoisted_11 = {
  key: 2,
  class: /*@__PURE__*/_normalizeClass('w-full hidden-component z-10')
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_block_loading = _resolveComponent("block-loading")!
  const _component_List = _resolveComponent("List")!
  const _component_restriction_alert = _resolveComponent("restriction-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass('flex content-main gap-5 ' + (_ctx.action.component ? ' half-it' : ''))
      }, [
        (_ctx.can_view_or_manage_vault)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.loadingBadges)
                ? (_openBlock(), _createBlock(_component_block_loading, { key: 0 }))
                : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
                            type: "text",
                            class: "rounded w-full relative pl-9 h-[40px] bg-[#464851] align-top mr-4 border-0",
                            placeholder: "Search by Bank Deposit #, Transaction Type, or User"
                          }, null, 512), [
                            [_vModelText, _ctx.search]
                          ]),
                          _cache[12] || (_cache[12] = _createElementVNode("svg", {
                            width: "24",
                            height: "24",
                            class: "absolute top-[9px] left-[8px]",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M19.9 20.9751L13.325 14.4001C12.825 14.8334 12.2417 15.1709 11.575 15.4126C10.9083 15.6543 10.2 15.7751 9.45 15.7751C7.65 15.7751 6.125 15.1501 4.875 13.9001C3.625 12.6501 3 11.1418 3 9.3751C3 7.60843 3.625 6.1001 4.875 4.8501C6.125 3.6001 7.64167 2.9751 9.425 2.9751C11.1917 2.9751 12.6958 3.6001 13.9375 4.8501C15.1792 6.1001 15.8 7.60843 15.8 9.3751C15.8 10.0918 15.6833 10.7834 15.45 11.4501C15.2167 12.1168 14.8667 12.7418 14.4 13.3251L21 19.8751L19.9 20.9751ZM9.425 14.2751C10.775 14.2751 11.925 13.7959 12.875 12.8376C13.825 11.8793 14.3 10.7251 14.3 9.3751C14.3 8.0251 13.825 6.87093 12.875 5.9126C11.925 4.95426 10.775 4.4751 9.425 4.4751C8.05833 4.4751 6.89583 4.95426 5.9375 5.9126C4.97917 6.87093 4.5 8.0251 4.5 9.3751C4.5 10.7251 4.97917 11.8793 5.9375 12.8376C6.89583 13.7959 8.05833 14.2751 9.425 14.2751Z",
                              fill: "white"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", {
                              class: "relative",
                              tabIndex: "0",
                              onBlur: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeDropDown && _ctx.closeDropDown(...args)))
                            }, [
                              _createElementVNode("div", {
                                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleDropDown && _ctx.toggleDropDown(...args))),
                                class: "text-white bg-theme-green hover:bg-green-600 py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"
                              }, [...(_cache[7] || (_cache[7] = [
                                _createElementVNode("span", null, [
                                  _createElementVNode("svg", {
                                    fill: "currentColor",
                                    width: "32",
                                    height: "32",
                                    viewBox: "0 0 24 24",
                                    xmlns: "http://www.w3.org/2000/svg"
                                  }, [
                                    _createElementVNode("path", { d: "M19,13H13V19H11V13H5V11H11V5H13V11H19V13Z" })
                                  ])
                                ], -1)
                              ]))]),
                              (_ctx.toggleAddDropDown)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "absolute right-0 -top-4 right-4 h-0 w-0 border-x-8 border-x-transparent border-b-[16px] border-b-gray-black" }, null, -1)),
                                    _createElementVNode("ul", _hoisted_9, [
                                      _createElementVNode("li", {
                                        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.openModal('BankDeposit')), ["prevent"])),
                                        role: "option",
                                        class: "cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9"
                                      }, [...(_cache[8] || (_cache[8] = [
                                        _createElementVNode("div", { class: "flex items-center" }, [
                                          _createElementVNode("span", { class: "ml-3 block text-white font-normal truncate uppercase" }, " Bank Deposit ")
                                        ], -1)
                                      ]))]),
                                      _createElementVNode("li", {
                                        onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.openModal('AddCash')), ["prevent"])),
                                        role: "option",
                                        class: "cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9"
                                      }, [...(_cache[9] || (_cache[9] = [
                                        _createElementVNode("div", { class: "flex items-center" }, [
                                          _createElementVNode("span", { class: "ml-3 block text-white font-normal truncate uppercase" }, " Add/Remove Cash ")
                                        ], -1)
                                      ]))]),
                                      _createElementVNode("li", {
                                        onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.openModal('SafeAudit')), ["prevent"])),
                                        role: "option",
                                        class: "cursor-pointer hover:bg-light-black text-gray-900 select-none relative py-2 pl-3 pr-9"
                                      }, [...(_cache[10] || (_cache[10] = [
                                        _createElementVNode("div", { class: "flex items-center" }, [
                                          _createElementVNode("span", { class: "ml-3 block text-white font-normal truncate uppercase" }, " Safe Audit ")
                                        ], -1)
                                      ]))])
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ], 32),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("button", {
                                onClick: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (_ctx.openModal('CloseVault')), ["prevent"])),
                                class: "font-normal text-base leading-5 text-[#2BA66B]"
                              }, "Close Vault")
                            ])
                          ])
                        ])
                      ])
                    ]),
                    _createVNode(_component_List, {
                      current: false,
                      selectedCallback: _ctx.selectedItem,
                      search: _ctx.search,
                      clearComponent: _ctx.clearComponent,
                      iscomponentactive: _ctx.action.component ? true : false
                    }, null, 8, ["selectedCallback", "search", "clearComponent", "iscomponentactive"])
                  ]))
            ]))
          : (_openBlock(), _createBlock(_component_restriction_alert, { key: 1 })),
        (_ctx.action.component)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.action.component), {
                item: _ctx.action.data,
                clearComponent: _ctx.clearComponent
              }, null, 8, ["item", "clearComponent"]))
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    _createElementVNode("div", null, [
      (_ctx.cashModal.popup)
        ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.cashModal.type), {
            key: 0,
            onClose: _ctx.closeCreate,
            totalBalance: _ctx.totalBalance
          }, null, 40, ["onClose", "totalBalance"]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}